var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hnw-oss-img",on:{"click":_vm.getImg}},[_c('el-image',{style:({width:_vm.width+'px',height:_vm.width+'px'}),attrs:{"src":_vm.picture,"preview-src-list":_vm.srcList},on:{"error":function($event){return _vm.imageError()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }